<!-- http://localhost:4200/shop/Group/Countries/Uruguay/0/0/0/0/0/0/0/sort-by-Price-Low-to-High -->
<!--<div class="container" style="height:100vh" *ngIf="bloquear"></div>-->

<div class="container">
  <div class="row mr-auto ml-auto" id="top">
    <mat-drawer-container class="tam-conteiner" autosize>
      <mat-drawer #drawer mode="side" [opened]="open" class="filters">
        <div class="row w-100 mx-auto">
          <div class="col-12">
            <div class="row filter-cabezera">
              <!-- <div class="col-6 col-md-6 text-left my-auto fil-title">
                FILTER
              </div> -->
              <div class="col-12 text-right my-auto fil-hide" (click)="drawer.toggle();targetCol = !targetCol;">
                Hide filters
                <mat-icon>highlight_off</mat-icon>
              </div>
            </div>
            <div class="row res-search-home filters-scroll">
              <!-- filtros vienen del search -->
              <div class="text-left my-auto" *ngFor="let chips of chipsFilters" (click)="removeChip(chips.id)">
                <ng-container *ngIf="chips.id != 'travelStyles'">
                  <div class="chips">
                    <mat-icon>highlight_off</mat-icon>
                    {{ chips.text }}
                  </div>
                </ng-container>
              </div>
              <!-- /filtros vienen del search -->
              <div class="col-md-12 text-center remove" (click)="removeFilters()" *ngIf="chipRemove">
                Remove all filters
              </div>
              <!-- Trip styles -->
              <div id="travelStyle" #travelStyle class="d-block w-100 h-100"></div>
              <div class="col-md-12 region-search" style="margin-bottom: 18px;">
                <p class="which-region">TRIP STYLE:</p>
                <div class="row">
                  <ng-container *ngFor="let ts of travelStyles; let i=index">
                    <ng-container *ngIf="ts.shortName != 'Tailor-made'">
                      <div class="col-6 pb-1 padding-col" matRipple matRippleColor="rgba(47, 193, 209, .3)"
                           matRippleCentered="true" (click)="selectTravelStyles(ts.lemaxId, ts.shortName)">
                        <p class="seo-trip-style-filter region-filter {{(targetsTravel[ts.lemaxId])?'region-filter-active':''}}">
                          {{ ts.shortName | uppercase }}
                        </p>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <!-- /Trip styles -->
              <!-- Regions -->
              <div id="region" #region class="d-block w-100 h-100"></div>
              <div class="col-md-12 region-search" style="margin-bottom: 18px;">
                <p class="which-region">REGION:</p>
                <div class="row">
                  <ng-container *ngFor="let r of regions;let i = index">
                    <div class="col-6 pb-1 padding-col" matRipple matRippleColor="rgba(47, 193, 209, .3)"
                         matRippleCentered="true" (click)="browseText = r.title;selectRegion(i)">
                      <p class="seo-region-filter region-filter {{(targetsRegion[i])?'region-filter-active':''}}">
                        {{ r.title | uppercase }}
                      </p>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- /Regions -->
              <!-- Country -->
              <div id="country" #country class="d-block w-100 h-100"></div>
              <div class="col-md-12 region-search" style="margin-bottom: 18px;" *ngIf="countriesEncontradas.length > 0">
                <p class="which-region">COUNTRY:</p>
                <div class="row">
                  <ng-container *ngFor="let ce of countriesEncontradas | slice:0:countriesMax;let i = index">
                    <div
                      class="pb-1 {{( (i+1) == countriesEncontradas.length && (countriesEncontradas.length % 2) != 0)?'col-12':'col-6 padding-col'}}"
                      matRipple matRippleColor="rgba(47, 193, 209, .3)" matRippleCentered="true">
                      <p class="seo-country-filter region-filter {{(targetsCountry[i])?'region-filter-active':''}}"
                         (click)="selectCountry(i,ce.name)">
                        {{ ce.name | uppercase }}
                      </p>
                    </div>
                  </ng-container>
                </div>
                <p class="region-filter" *ngIf="!banderaMC" (click)="moreCountries()">
                  MORE COUNTRIES
                </p>
                <p class="region-filter" *ngIf="banderaMC" (click)="minusCountries()">
                  LESS COUNTRIES
                </p>
              </div>
              <!-- /Country -->
              <!-- HOW LONG -->
              <div id="howLongAncla" #howLongAncla class="d-block w-100 h-100"></div>
              <div class="col-md-12 region-search" style="margin-bottom: 18px;">
                <p class="which-region">HOW LONG?</p>
                <div class="row">
                  <ng-container *ngFor="let l of long; let i = index">
                    <div class="pb-1 {{( (i+1) == long.length && (long.length % 2) != 0)?'col-12':'col-6 padding-col'}}"
                         (click)="selectHowLong(i,l.viewValue,true)"
                         matRipple matRippleColor="rgba(47, 193, 209, .3)" matRippleCentered="true">
                      <p class="seo-duration-filter region-filter {{(targetsLong[i])?'region-filter-active':''}}">
                        {{ l.viewValue | uppercase }}
                      </p>
                    </div>
                  </ng-container>
                  <div class="custom-slider col-md-12">
                    <ng5-slider *ngIf="banderaL"
                                [(value)]="valueMinL"
                                [(highValue)]="valueMaxL"
                                [options]="optionsL"
                                (userChangeEnd)="howLongChangeValue()"></ng5-slider>
                  </div>
                </div>
              </div>
              <!-- /HOW LONG -->
              <!-- BUDGET -->
              <div id="budgetAncla" #budgetAncla class="d-block w-100 h-100"></div>
              <div class="col-md-12 region-search" style="margin-bottom: 18px;">
                <p class="which-region">BUDGET:</p>
                <div class="row">
                  <ng-container *ngFor="let b of budget; let i = index">
                    <div class="col-6 pb-1 padding-col" (click)="selectBudget(i,b.viewValue)" matRipple
                         matRippleColor="rgba(47, 193, 209, .3)" matRippleCentered="true">
                      <p class="seo-budget-filter region-filter {{(targetsBudget[i])?'region-filter-active':''}}">
                        {{ b.viewValue }}
                      </p>
                    </div>
                  </ng-container>
                  <div class="custom-slider col-md-12">
                    <ng5-slider *ngIf="banderaB"
                                [(value)]="valueMin"
                                [(highValue)]="valueMax"
                                [options]="optionsB"
                                (userChangeEnd)="budgetChangeValue()"></ng5-slider>
                  </div>
                </div>
              </div>
              <!-- /BUDGET -->
              <!-- check -->
              <div id="recommended" #recommended class="d-block w-100 h-100"></div>
              <div class="col-md-12 mt-2 check" style="margin-bottom: 18px;">
                <mat-checkbox class="seo-bamba-recommended-filter" [(ngModel)]="bambaRecommendedTrip"
                              (change)="selectCheck()">bamba Recommended Trip
                </mat-checkbox>
                <mat-icon matTooltip="hand-picked amazing experiences">help</mat-icon>
              </div>
              <!-- /check -->
              <!-- Themes -->
              <div class="col-md-12 region-search" id="themes" style="margin-bottom: 18px;">
                <p class="which-region">WHAT DO YOU WANT TO DO?</p>
                <div class="row">
                  <ng-container *ngFor="let t of themesC | slice:0:themeMax;let i = index">
                    <div
                      class="pb-1 {{( (i+1) == themesC.length && (themesC.length % 2) != 0)?'col-12':'col-6 padding-col'}}"
                      (click)="selectThemes(i,t.name)" matRipple matRippleColor="rgba(47, 193, 209, .3)"
                      matRippleCentered="true">
                      <p class="seo-theme-filter region-filter {{(targetsThemes[i])?'region-filter-active':''}}">
                        {{ t.name | uppercase }}
                      </p>
                    </div>
                  </ng-container>
                </div>
                <p class="region-filter" *ngIf="!banderaMT" (click)="moreThemes()">
                  MORE THEMES
                </p>
                <p class="region-filter" *ngIf="banderaMT" (click)="minusThemes()">
                  LESS THEMES
                </p>
              </div>
              <!-- /Themes -->

            </div>
          </div>
        </div>
      </mat-drawer>

      <div class="w-100 filters-result">
        <div class="col-12">
          <!-- RESULTS SLIDER TOGGLE -->
          <!-- -------------{{bloquear}} -->
          <div class="row separator">
            <div class="fil-show-smart my-auto col-4 pl-3 pr-0" (click)="drawer.toggle();open = !open"
                 [ngStyle]="{'display':open ? 'none' : 'block'}">
              Show filters
            </div>
            <div class="fil-show col-md-4 col-xl-3 col-lg-3 my-auto pl-4"
                 (click)="drawer.toggle();targetCol = !targetCol;" [ngStyle]="{'display':targetCol ? 'none' : 'block'}">
              Show Filters
            </div>
            <div class="col-8 text-right my-auto d-block d-md-none">
              <div class="d-flex bd-highlight float-right">
                <div class="pr-2 bd-highlight my-auto">
                  <h1 class="h1-color m-0" [ngStyle]="{'color': checked?'#75787B':'#2FC1D1'}">PICS</h1>
                </div>
                <div class="pr-2 bd-highlight">
                  <mat-slide-toggle [(ngModel)]="checked"></mat-slide-toggle>
                </div>
                <div class="pr-2 bd-highlight my-auto">
                  <h1 class="h1-color m-0" [ngStyle]="{'color': checked?'#2FC1D1':'#75787B'}">MAPS</h1>
                </div>
              </div>
            </div>
            <div
              class="{{ targetCol ? 'col-12 col-md-4 col-lg-6 col-xl-6' : 'col-md-4' }} text-center text-md-left my-auto banner-result">
              <div class="row">
                <div class="col-6 my-auto">
                  <h1 class="m-0"><span>RESULTS:</span> {{ totalNumberOfResults }} TRIPS </h1>
                </div>
                <div class="col-6 mt-2 select-filter">
                  <form [formGroup]="sortByForm">
                    <mat-form-field>
                      <mat-select placeholder="Sort by" formControlName="sortBy" (selectionChange)="sortBySelect()">
                        <mat-option *ngFor="let sort of sortBy" [value]="sort.text">{{ sort.text }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="{{ targetCol ? 'col-md-4 col-lg-6 col-xl-6' : 'col-md-4 col-lg-5 col-xl-5' }} text-right my-auto  d-none d-md-block">
              <div class="d-flex bd-highlight float-left float-sm-left float-md-right  float-lg-right float-xl-right">
                <div class="pr-2 bd-highlight my-auto">
                  <h1 class="h1-color m-0" [ngStyle]="{'color': checked?'#75787B':'#2FC1D1'}">PICS</h1>
                </div>
                <div class="pr-2 bd-highlight">
                  <mat-slide-toggle [(ngModel)]="checked"></mat-slide-toggle>
                </div>
                <div class="pr-2 bd-highlight my-auto">
                  <h1 class="h1-color m-0" [ngStyle]="{'color': checked?'#2FC1D1':'#75787B'}">MAPS</h1>
                </div>
              </div>
            </div>
          </div>
          <!-- END RESULTS SLIDER TOGGLE -->
        </div>
      </div>

      <ng-container *ngIf="bloquear">
        <mat-spinner style="margin: 40px auto" [diameter]="30"></mat-spinner>
      </ng-container>

      <div class="w-100 filters-result" *ngIf="totalNumberOfResults != 0; else notResults">
        <div class="col-md-12">
          <!-- FILTERS TRAVEL STYLES -->
          <!-- <div class="row">
            <div class="fil-show-smart col-6 pl-3 pr-0" (click)="drawer.toggle();open = !open" [ngStyle]="{'display':open ? 'none' : 'block'}" >
              Show filters
            </div>
            <div class="fil-show col-1 pr-0" (click)="drawer.toggle();targetCol = !targetCol;" [ngStyle]="{'display':targetCol ? 'none' : 'block'}" >
              Show filters
            </div>
            <mat-form-field class="col-6 d-block d-sm-block d-md-block d-lg-none d-xl-none" style="padding-top:13px;">
              <mat-select [(value)]="selected">
                <ng-container *ngFor="let ts of travelStyles; let i=index">
                  <mat-option selected="true" *ngIf="ts.shortName != 'Tailor-made'" [value]="ts.lemaxId" (click)="selectTravelStyles(i, ts.shortName)">{{ ts.shortName }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
            <ng-container *ngFor="let ts of travelStyles; let i=index">
              <ng-container *ngIf="ts.shortName != 'Tailor-made'">
                <div class="{{(!targetCol)?'col-md-2':'col-md-3'}} d-none d-sm-none d-md-none d-lg-block d-xl-block" (click)="selectTravelStyles(i, ts.shortName)">
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn {{(targetsTravel[i])?'btn-active':''}}" >
                      <mat-card>
                        <img mat-card-image mat-card-image-no-shadow class="card-travle" [src]="ts.coverPhoto" [alt]="ts.shortName">
                        <mat-card-content>
                          <p>
                            {{ ts.shortName }}
                          </p>
                        </mat-card-content>
                      </mat-card>
                    </button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
           </div> -->
          <!-- END FILTERS TRAVEL STYLES -->


          <!-- FILTERS -->
          <div class="row top-banner">
            <ng-container *ngFor="let f of searchResults;let i = index">
              <div
                class="border-card {{ (targetCol)?'col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4':'col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3' }}"
                style="margin-bottom: 60px">
                <a class="detail-product">
                  <mat-card>
                    <ng-container *ngIf="!checked">
                      <div id="filters{{i+1}}" class="carousel slide" data-ride="carousel" data-interval="3000"
                           style="z-index:1;cursor:pointer;">
                        <ol class="carousel-indicators">
                          <!-- <ng-container *ngIf="f.Galery.length >= 2"> -->
                          <li attr.data-target="#filters{{i+1}}"
                              [attr.data-slide-to]="j"
                              *ngFor="let g of f.Galery;let j = index"
                              [ngClass]="{'active' : j == 0}">
                          </li>
                          <!-- </ng-container> -->
                        </ol>
                        <div class="carousel-inner">
                          <div class="discount" *ngIf="f.PriceInfo?.Discount != null">
                            SAVE {{ f.PriceInfo?.Discount?.Percent }}%
                          </div>
                          <div class="discount" *ngIf="f.PriceInfo?.SpecialOffer != null">
                            SAVE ${{ f.PriceInfo?.SpecialOffer?.Discount }}
                          </div>
                          <ng-container *ngIf="f.Galery.length > 0">
                            <div class="carousel-item"
                                 (panleft)="sliderCarusel('left',i,'filters')"
                                 (panright)="sliderCarusel('right',i,'filters')"
                                 *ngFor="let g of f.Galery; let k = index"
                                 [ngClass]="{'active': k == 0}">

                              <a [routerLink]="['/adventure',
                                  (f.Countries[0]?.name +'-'+ f.Style[0]?.Permalink +'-'+ f.MainTheme[0]?.MainThemeName) | urlEspacios,
                                  f.TourTitle | urlEspacios,
                                  f.TourID,
                                  f.Type]"
                                 target="_blank">

                                <ng-container
                                  *ngIf="isVideo(g); else imageTemplate">
                                  <video mat-card-image #videoElement
                                         style="z-index:100; height: 200px; width: 100%; object-fit: cover;"
                                         muted autoplay loop >
                                    <source [src]="g.ThumbnailUrl" [type]="getVideoType(g)">
                                    Your browser does not support the video tag.
                                  </video>
                                </ng-container>

                                <ng-template #imageTemplate>
                                  <img mat-card-image style="z-index:100;" [src]="g.ThumbnailUrl" [alt]="f.TourTitle">
                                </ng-template>

                              </a>

                            </div>
                          </ng-container>
                          <ng-container *ngIf="f.Galery.length == 0">
                            <div class="carousel-item active">
                              <a
                                [routerLink]="['/adventure',(f.Countries[0]?.name +'-'+ f.Style[0]?.Permalink +'-'+ f.MainTheme[0]?.MainThemeName) | urlEspacios,f.TourTitle | urlEspacios,f.TourID,f.Type]"
                                target="_blank">
                                <img mat-card-image style="z-index:100;" src="assets/img/NoImage.png">
                              </a>
                            </div>
                          </ng-container>
                        </div>
                        <!-- <a class="carousel-control-prev" href="#filters{{i+1}}" role="button" data-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#filters{{i+1}}" role="button" data-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="sr-only">Next</span>
                        </a> -->
                      </div>
                    </ng-container>
                    <ng-container *ngIf="checked">
                      <a
                        [routerLink]="['/adventure',(f.Countries[0]?.name +'-'+ f.Style[0]?.Permalink +'-'+ f.MainTheme[0]?.MainThemeName) | urlEspacios,f.TourTitle | urlEspacios,f.TourID,f.Type]"
                        target="_blank">
                        <img mat-card-image class="img-maps img-thumbnail" [alt]="f.TourTitle" style="cursor:pointer"
                             [src]="(f.Mapa?.ThumbnailUrl == null)?'assets/img/MapInProgress.jpg':f.Mapa.ThumbnailUrl">
                      </a>
                    </ng-container>
                    <a
                      [routerLink]="['/adventure',(f.Countries[0]?.name +'-'+ f.Style[0]?.Permalink +'-'+ f.MainTheme[0]?.MainThemeName) | urlEspacios,f.TourTitle | urlEspacios,f.TourID,f.Type]"
                      target="_blank">
                      <mat-card-content style="cursor:pointer">
                        <mat-card-title>
                          <div [ngSwitch]="f.Style[0]?.lemaxId">
                            <p *ngSwitchCase="6" class="title-travel-pass">
                              {{ f.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchCase="7" class="title-group">
                              {{ f.Style[0]?.shortName }}
                            </p>
                            <p *ngSwitchDefault class="title-independent">
                              {{ f.Style[0]?.shortName }}
                            </p>
                          </div>
                          <p class="sub-country">
                            {{ f.TourTitle }}
                          </p>
                          <p class="sub-recommended">
                            {{ f.MainTheme[0]?.MainThemeName }}
                          </p>
                          <p class="country" *ngIf="f.Countries != null">
                            {{ f.Countries[0]?.name }}
                            <span *ngIf="f.NumberOfCountries >= 2"> +{{ f.NumberOfCountries - 1 }} </span>
                            <ng-container *ngIf="f.DurationDD != null && f.DurationHR == null">
                              / {{ f.DurationDD }} Days
                            </ng-container>
                            <ng-container *ngIf="f.DurationHR != null">
                              / 1 Day
                            </ng-container>
                          </p>
                          <p class="price" *ngIf="f.PriceInfo?.Price > 0">
                            From
                            <span class="price-discount"
                                  *ngIf="f.PriceInfo?.Discount != null">${{ f?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-discount"
                                  *ngIf="f.PriceInfo?.SpecialOffer != null">${{ f?.PriceInfo?.PriceOriginalFormatted | roundDecimal }}</span>
                            <span class="price-total"
                                  *ngIf="f.PriceInfo?.Discount == null && f.PriceInfo?.SpecialOffer == null">${{ f?.PriceInfo?.PriceFormatted | roundDecimal }}
                              USD</span>
                            <span class="price-total"
                                  *ngIf="f.PriceInfo?.Discount != null || f.PriceInfo?.SpecialOffer != null">${{ f?.PriceInfo?.PriceFormatted }}
                              USD</span>
                          </p>

                          <!-- AUN NO SE PROGRAMARA ESTA SECCION -->
                          <!-- <p class="starts">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar2.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            <img src="assets/img/shared/iconStar.svg" alt="">
                            199 reviews
                          </p> -->
                        </mat-card-title>
                      </mat-card-content>
                    </a>
                  </mat-card>
                </a>
              </div>
            </ng-container>
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="1000"
              (scrolled)="onScroll()">
            </div>
            <div class="col-md-12 mb-5">
              <ng-container
                *ngIf="(!finished && totalNumberOfResults != 0) && totalNumberOfResults != searchResults?.length">
                <mat-spinner style="margin: 0 auto" [diameter]="30"></mat-spinner>
              </ng-container>
              <ng-container *ngIf="finished || totalNumberOfResults == searchResults?.length">
                <div class="container notResults infinity-scroll">
                  <div class="row ">
                    <div class="col-12 my-auto text-center">
                      <p class="title">
                        Sorry, we have no more trips!
                      </p>
                      <p class="content col-12 col-md-9 mx-auto">
                        Please <span class="ir-arriba" (click)="irArriba('top')" style="cursor:pointer">update your filters</span>
                        <span class="ir-arriba-smart" (click)="irArriba('top',true);drawer.toggle()"
                              style="cursor:pointer">update your filters</span>
                        on the left or we are also happy to quote a
                        <strong>Tailor-Made trip</strong> for you, free of charge.
                      </p>
                      <div class="row justify-content-center">
                        <div class="col-md-4">
                          <button [routerLink]="['/','tailor-made']" class="btn btn-secundary" type="button"
                                  name="button">
                            Help me plan my trip
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- END FILTERS -->
        </div>
      </div>

      <!-- NOT REDULTS -->
      <ng-template #notResults>
        <ng-container *ngIf="!bloquear">
          <div class="container notResults">
            <div class="row ">
              <div class="col-12 my-auto text-center">
                <p class="title underline d-none d-xl-block d-xl-block">
                  Sorry, we could not find any trips!
                </p>
                <p class="title underline d-block d-xl-none d-xl-none" (click)="drawer.toggle()">
                  Sorry, we could not find any trips!
                </p>
                <p class="content col-12 col-md-9 mx-auto">
                  Please remove some of your filters on the left or we are also
                  happy to quote a <strong>Tailor-Made trip</strong> for you,
                  free of charge.
                </p>
                <div class="row justify-content-center">
                  <div class="col-md-4">
                    <button [routerLink]="['/','tailor-made']" class="btn btn-secundary" type="button" name="button">
                      Help me plan my trip
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>
      <!-- END NOT RESULTS -->

    </mat-drawer-container>
  </div>
</div>


<!--<app-bloqueo [visible]="bloquear"></app-bloqueo>-->
